<template>
    <v-container>
        <v-layout raw align-center class="admin-item">
            <v-text-field prepend-icon="update"
                          single-line
                          v-model="tour"
                          type="number"
                          label="Сменить тур"></v-text-field>
            <v-btn icon
                   class="send-button"
                   @click="submitMatchDay"
                   color="blue-grey">
                <v-icon dark>send</v-icon>
            </v-btn>
        </v-layout>
        <v-layout raw align-center class="admin-item">
            <v-file-input
                    v-model="file"
                    :show-size="1000"
                    label="Cоставы"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            >
                <template v-slot:selection="{ index, text }">
                    <v-chip
                            v-if="index < 2"
                            color="blue-grey"
                            dark
                            label
                            small
                    >
                        {{ text }}
                    </v-chip>
                    <span
                            v-else-if="index === 2"
                            class="overline grey--text text--darken-3 mx-2"
                    >
        +{{ files.length - 2 }} File(s)
      </span>
                </template>
            </v-file-input>
            <v-btn icon
                   class="send-button"
                   v-show="file"
                   @click="submitFile"
                   color="blue-grey">
                <v-icon dark>send</v-icon>
            </v-btn>
        </v-layout>
        <v-layout raw align-center class="admin-item">
            <v-file-input
                    v-model="resultsFile"
                    :show-size="1000"
                    label="Результаты"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            >
                <template v-slot:selection="{ index, text }">
                    <v-chip
                            v-if="index < 2"
                            color="blue-grey"
                            dark
                            label
                            small
                    >
                        {{ text }}
                    </v-chip>
                    <span
                            v-else-if="index === 2"
                            class="overline grey--text text--darken-3 mx-2"
                    >
        +{{ files.length - 2 }} File(s)
      </span>
                </template>
            </v-file-input>
            <v-btn icon
                   class="send-button"
                   v-show="resultsFile"
                   @click="submitResults"
                   color="blue-grey">
                <v-icon dark>send</v-icon>
            </v-btn>
        </v-layout>
        <v-textarea
                readonly
                outlined
                auto-grow
                class="admin-item"
                no-resize
                v-model="rostersText"
                append-icon="mdi-content-copy"
                @click:append="copyText"
                id="tocopy"
        >

        </v-textarea>

    </v-container>
</template>

<script>
    import parser from '../converter'
    import firebase from "firebase";

    export default {
        data() {
            return {
                file: [],
                resultsFile: [],
                tour: null,
                prevTour: null,
                rostersText: ''
            }
        },
        props: ['matchday', 'teams', 'prevMatchday'],
        watch: {
            matchday: {
                immediate: true,
                handler(newValue, oldValue) {
                    if (this) {
                        this.prevTour = oldValue
                        this.tour = newValue;
                    }
                }
            },
            prevMatchday: {
                immediate: true,
                handler(newValue, oldValue) {
                    if (this) {
                        this.prevTour = newValue;
                    }
                }
            },
            teams: {
                immediate: true,

                handler(newValue, oldValue) {
                    if (this) {
                        this.rostersText = '';
                        if (this.tour > 0) {
                            this.rostersText = 'Составы на ';
                            this.rostersText += this.prevTour
                            this.rostersText += " тур\n\n"
                        }
                        for (let i in newValue) {
                            let team = newValue[i];
                            this.rostersText += team.title;
                            this.rostersText += '\n\n';

                            for (let i in team.players) {
                                let player = team.players[i];
                                this.rostersText += player.name;
                                this.rostersText += '\n';

                                if (i == 1 || i == 6 || i == 11) {
                                    this.rostersText += Math.floor(i / 5) + 1
                                    this.rostersText += ' пятерка'
                                    this.rostersText += '\n'
                                }
                            }

                            this.rostersText += '\n\n'
                        }
                    }
                }
            }
        },
        methods: {
            copyText() {
                let input = document.getElementById("tocopy");
                input.select();
                document.execCommand("copy");
            },
            groupPlayers(players) {
                let groupedPlayers = [];
                for (let i in players) {
                    let player = players[i];
                    let team = player.team;
                    if (groupedPlayers.find(item => {
                        return player.team === item.team
                    })) {
                        groupedPlayers.find(item => {
                            return player.team === item.team
                        }).players.push(player)
                    } else {
                        groupedPlayers.push({team: team, players: [player]})
                    }
                }
                return groupedPlayers
            },
            submitMatchDay() {
                firebase
                    .firestore()
                    .collection("config")
                    .get()
                    .then(config => {
                        // eslint-disable-next-line no-console
                        console.log('document reads', config.size)
                        let doc = config.docs[0]
                        if (doc) {
                            firebase
                                .firestore()
                                .doc(doc.ref.path)
                                .set({
                                    prevMatchday: Math.min(doc.data().matchday, this.tour),
                                    matchday: this.tour
                                })
                        }
                        this.matchday = config.docs[0].data().matchday
                    })
            },
            submitFile() {
                const reader = new FileReader();
                // eslint-disable-next-line no-unused-vars
                reader.onload = e => {
                    let players = parser({
                        source: reader.result,
                        header: {
                            rows: 1
                        },
                        sheets: ['Players'],
                        columnToKey: {
                            B: 'name',
                            C: 'team',
                            D: 'pos',
                            E: 'realTeam'
                        }
                    }).Players;
                    let groupedPlayers = this.groupPlayers(players);
                    this.sendPlayers(groupedPlayers)
                };
                reader.readAsArrayBuffer(this.file);
            },
            submitResults() {

                let ref = firebase
                    .app()
                    .storage('gs://world-cup-manager.appspot.com')
                    .ref()
                    .child('Results.xlsx');

                    ref.put(this.resultsFile).then(function(snapshot) {
                        console.log('Uploaded an array!');
                    });
            },
            sendPlayers(groupedPlayers) {
                //GET TEAMS
                firebase
                    .firestore()
                    .collection('teams')
                    .get()
                    .then(snapshot => {
                        // eslint-disable-next-line no-console
                        console.log('document reads', snapshot.size)

                        let teams = [];
                        snapshot.forEach(doc => {
                            var team = doc.data();
                            team.uid = doc.id;
                            teams.push(team)
                        });


                        for (let i in teams) {
                            let team = teams[i];
                            let teamPlayers = groupedPlayers.find(obj => obj.team === team.title);
                            if (teamPlayers && teamPlayers.players) {
                                let players = teamPlayers.players
                                firebase
                                    .firestore()
                                    .collection("teams")
                                    .doc(team.uid)
                                    .collection("players")
                                    .get()
                                    .then(shapshot => {

                                        console.log('document reads', shapshot.size)

                                        let existingPlayers = [];
                                        shapshot.docs.forEach(doc => {
                                            let player = doc.data();
                                            player.ref = doc.ref.path;
                                            existingPlayers.push(player)
                                        });
                                        let playersToDelete = [];
                                        let playersToAdd = [];

                                        for (i in players) {
                                            let player = players[i];
                                            if (!existingPlayers.filter(obj => {
                                                return obj.name === player.name &&
                                                    obj.team === player.team &&
                                                    obj.realTeam === player.realTeam &&
                                                    obj.pos === player.pos
                                            }).length) {
                                                playersToAdd.push(player)
                                            }
                                        }


                                        for (i in existingPlayers) {
                                            let player = existingPlayers[i];
                                            if (!players.filter(obj => {
                                                return obj.name === player.name &&
                                                    obj.team === player.team &&
                                                    obj.realTeam === player.realTeam &&
                                                    obj.pos === player.pos
                                            }).length) {
                                                playersToDelete.push(player)
                                            }
                                        }

                                        for (i in playersToAdd) {
                                            firebase
                                                .firestore()
                                                .collection("teams")
                                                .doc(team.uid)
                                                .collection("players")
                                                .add(playersToAdd[i])
                                        }

                                        for (i in playersToDelete) {
                                            firebase
                                                .firestore()
                                                .doc(playersToDelete[i].ref)
                                                .delete()
                                        }
                                    });

                            }
                        }
                    })
            }
        }
    }

</script>

<style>

    .admin-item {
        width: 300px;
        max-width: 100%;
    }
</style>